import type { Extension } from "@codemirror/state";
import { EditorView } from "@codemirror/view";

/**
 * The zero-point placeholder of the Studio's document editors (input,
 * transform). It inherits the mono content font; Figma paints it in the
 * line-number gray, not the usual placeholder token. It stays on ONE line,
 * trimmed with an ellipsis in a narrow editor: the zero-point links hang
 * where line 2 would render (each editor's EmptyStateOverlay), so a
 * placeholder that wrapped would run under them (TTTL-186).
 */
export function singleLinePlaceholderRules(color: string) {
  return {
    ".cm-placeholder": {
      color,
      // The widget is an inline span; only a box takes a max width and an
      // ellipsis.
      display: "inline-block",
      maxWidth: "100%",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },
    // The wrapped content is a flex item of the scroller. Left at the
    // default min-width auto, the nowrap placeholder is its min-content
    // and widens it past the scroller — the 100% max width then never
    // bites and the text is clipped at the edge instead of trimmed.
    ".cm-content.cm-lineWrapping": {
      minWidth: "0",
    },
  };
}

export function singleLinePlaceholder(color: string): Extension {
  return EditorView.theme(singleLinePlaceholderRules(color));
}
